(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/service/deposit-limits-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/service/deposit-limits-service.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let jupiter;
const cleanResponse = response => {
  const cleaned = Object.assign({}, response);
  delete cleaned.requestId;
  delete cleaned.deviceId;
  delete cleaned.requestInfo;
  return cleaned;
};
if (isServer) {
  const trinidad = require('trinidad-core').core;
  jupiter = trinidad.jupiter;
  logger = trinidad.logger('game-limits-deposits-form');
} else {
  jupiter = svs.core.jupiter;
  logger = svs.accountservicesReact.logger;
}

const getDepositLimitsAsync = async req => {
  let api = 1;
  if (isServer && (await req.feature('ft-its-api-version')) || !isServer && svs.core.detect.feature('ft-its-api-version')) {
    api = 2;
  }
  const path = "/player/".concat(api, "/depositlimits");
  try {
    let response;
    let status;
    const options = {
      method: 'GET',
      path,
      data: {},
      req
    };
    if (isServer) {
      const apiResponse = await jupiter.callAsync(options);
      status = apiResponse ? 'success' : 'error';
      response = Boolean(apiResponse) && apiResponse;
    } else {
      ({
        response,
        status
      } = await jupiter.callAsync(options));
    }
    return {
      error: status === 'success' ? null : 'error',
      data: status === 'success' ? cleanResponse(response) : {}
    };
  } catch (err) {
    logger.info("Error Getting customer deposit limits ".concat(path), err);
    return {
      error: err,
      data: {}
    };
  }
};
const setDepositLimitAsync = async (limitTypesArray, depositBudgetsArray) => {
  let api = 1;
  if (svs.core.detect.feature('ft-its-api-version')) {
    api = 2;
  }
  const path = "/player/".concat(api, "/depositlimits");
  try {
    const options = {
      method: 'PUT',
      path,
      data: {
        limitTypes: limitTypesArray,
        depositBudgets: depositBudgetsArray
      }
    };
    const {
      response,
      status
    } = await jupiter.callAsync(options);
    return {
      error: status === 'success' ? null : 'error',
      data: status === 'success' ? cleanResponse(response) : {}
    };
  } catch (err) {
    return {
      error: err,
      data: {}
    };
  }
};

if (isServer) {
  exports.getDepositLimitsAsync = getDepositLimitsAsync;
} else {
  svs.accountservicesReact.gameLimitDepositsForm.service = {
    getDepositLimitsAsync,
    setDepositLimitAsync
  };
}

 })(window);